export default __webpack_public_path__ + "static/media/offroad110000.d5f85667.jpg";